export default "__VITE_ASSET__298df0ce__"